/**
 * Проверка для switch наличия обработки для всех доступных вариантов. Помещается в default
 * @param {never} switchKey
 * @return {void}
 */

export const exhaustiveCheck = (switchKey: never): void => {};
